import { StarIcon } from "@heroicons/react/24/solid";
import Modal, { ModalActions } from "../Modal";
import Button from "../Button";
import Text from "@/common/Text";
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import { useGetUpgradeSubscriptionPortalSessionMutation } from "@/services/apis/api.ts";
import { assertNotUndefined } from "@/util/typeguards.ts";

const UpgradeDialog = ({
    onClose,
    open,
    title = "Upgrade Account",
    userIsAdmin,
}: {
    onClose: () => void;
    open: boolean;
    userIsAdmin: boolean;
    title?: string;
}) => {
    const [getSubscriptionPortalSession, { isLoading }] =
        useGetUpgradeSubscriptionPortalSessionMutation();

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={title}
            description={
                <>
                    <div>
                        Upgrade now to the Scale plan. After clicking
                        &apos;upgrade&apos;, you will be taken to a secure
                        checkout page where you can review the price and fill
                        out your payment details
                    </div>
                    {!userIsAdmin && (
                        <div className={"mt-4 mb-6 flex items-start gap-2"}>
                            <ExclamationTriangleIcon
                                className={"h-10 w-10 text-yellow-500"}
                            />
                            <Text weight="bold">
                                Only admin users can upgrade. Please contact an
                                admin user in your organization
                            </Text>
                        </div>
                    )}
                </>
            }
        >
            <ModalActions>
                <Button plain onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    loading={isLoading}
                    type="primary"
                    className={"ml-5"}
                    disabled={!userIsAdmin}
                    tooltip={
                        userIsAdmin
                            ? undefined
                            : "Only admins can change the plan"
                    }
                    onClick={async () => {
                        const result = await getSubscriptionPortalSession({
                            plan: "scale",
                            cadence: "monthly",
                        });
                        assertNotUndefined(result.data);
                        window.location.href = result.data.url;
                    }}
                    icon={StarIcon}
                >
                    Upgrade
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default UpgradeDialog;
